import Head from 'next/head'
import Image from 'next/image'

export default function Gallery() {
  const carImages = Array.from({ length: 13 }, (_, i) => `/images/cars/car-${i + 1}.webp`)

  return (
    <>
      <Head>
        <title>Fahrzeug-Galerie | Autoverwertung Deutschland</title>
        <meta name="description" content="Bildergalerie von Fahrzeugen, die wir verwerten und recyceln. Beispiele für nachhaltige Autoverwertung in Deutschland." />
        <meta property="og:title" content="Fahrzeug-Galerie | Autoverwertung Deutschland" />
        <meta property="og:description" content="Bildergalerie von Fahrzeugen, die wir verwerten und recyceln. Beispiele für nachhaltige Autoverwertung in Deutschland." />
         <meta property="og:image" content="/images/cars/reccar.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://autoverwertungs.de/gallery" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fahrzeug-Galerie | Autoverwertung Deutschland" />
        <meta name="twitter:description" content="Bildergalerie von Fahrzeugen, die wir verwerten und recyceln. Beispiele für nachhaltige Autoverwertung in Deutschland." />
        <meta name="twitter:image" content="/logo.jpeg" />
        <meta name="robots" content="index, follow" />
      </Head>
      <div className="container mx-auto px-4 py-8 md:py-12 lg:py-16">
        <div className="mb-8 md:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Fahrzeug-Galerie</h1>
          <p className="text-gray-600 text-base md:text-lg">
            Hier sind Beispiele von Fahrzeugen, die wir verwerten und recyceln.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {carImages.map((img, idx) => (
            <div
              key={idx}
              className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="relative w-full h-48 sm:h-56 md:h-64">
                <Image
                  src={img}
                  alt={`Fahrzeug ${idx + 1}`}
                  fill
                  quality={80}
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  className="object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                <span className="text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  Fahrzeug {idx + 1}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
